import { DataContext } from 'components/common-form/contexts/DataContext';
import { FieldMetadataContext } from 'components/common-form/contexts/FieldMetadataContext';
import { useSPIntl } from 'hooks/useIntl';
import { useContext } from 'react';
import { camelCaseToWords } from 'utils/string';

interface SolvedFields {
  label: string;
  value: number;
}
export function useSolvedFields(): SolvedFields[] {
  const metadataById = useContext(FieldMetadataContext);
  const [dataById] = useContext(DataContext);

  const { formatMessage } = useSPIntl();
  return Object.values(metadataById ?? {})
    .filter(m => m?.isHighlighted && m?.isHidden !== true)
    .map(m => {
      return {
        label: formatMessage({
          id: (m.translationKey ? `form.${m.translationKey}` : m.id) as any,
          defaultMessage: camelCaseToWords(m.id),
        }),
        value: dataById[m.id] as number,
      };
    });
}
